<h2 mat-dialog-title i18n>Your Privacy & Experience</h2>
<mat-dialog-content class="mat-typography">
  <div class="flex flex-col gap-6">
  <p i18n>
    We want to provide the best possible experience. To do this, we use specialized tools to find problems and understand how our application is used.
  </p>
  <p class="font-medium text-green-700 bg-green-50 p-3 rounded-md border border-green-200" i18n>
    <strong>Important:</strong> All data is strictly <strong>anonymized</strong>. We do <strong>NOT</strong> collect or send any personal data, names, email addresses, or uploaded files. These tools are only used for technical improvements.
  </p>

  @if (showDetails()) {
    <div class="p-4 bg-gray-50 rounded-lg border border-gray-200">
      <div class="flex flex-col gap-6">
        <div>
          <mat-checkbox [(ngModel)]="consent.sentry" color="primary">
            <span class="font-bold text-base" i18n>Error Tracking (Sentry)</span>
          </mat-checkbox>
          <p class="ml-8 mt-1 text-sm text-gray-600" i18n>
            Automatically reports technical crashes and performance bottlenecks so we can fix them before they affect you.
          </p>
        </div>
        <div>
          <mat-checkbox [(ngModel)]="consent.posthog" color="primary">
            <span class="font-bold text-base" i18n>Product Usage (PostHog)</span>
          </mat-checkbox>
          <p class="ml-8 mt-1 text-sm text-gray-600" i18n>
            Helps us identify which features are most useful and where the user interface might be confusing.
          </p>
        </div>
      </div>
    </div>
  } @else {
    <p class="text-sm text-gray-500 italic" i18n>
      By clicking "Accept All", you help us build a better and more stable application.
    </p>
  }

  <div class="flex items-center gap-4 text-sm w-full justify-center">
    <a routerLink="/imprint" class="text-primary-600 hover:text-primary-700 font-medium transition-colors" i18n>Imprint</a>
    <span class="w-1 h-1 rounded-full bg-gray-300"></span>
    <a routerLink="/privacy" class="text-primary-600 hover:text-primary-700 font-medium transition-colors" i18n>Privacy Policy</a>
  </div>

  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="p-4 gap-3 bg-gray-50">
  <button mat-button (click)="toggleDetails()" class="text-gray-500">
    @if (showDetails()) { <span i18n>Hide Details</span> } @else { <span i18n>Customize Settings...</span> }
  </button>
  <button mat-button color="warn" (click)="rejectAll()" i18n>Only Essential</button>
  @if (showDetails()) {
    <button mat-stroked-button color="primary" (click)="save()" i18n>Save My Choice</button>
  }
  <button mat-flat-button color="primary" class="font-bold text-lg px-10 py-3 shadow-lg transform hover:scale-105 transition-transform" (click)="acceptAll()" i18n>Accept All & Continue</button>
</mat-dialog-actions>
